import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import { CallApi } from "app/_helpers/CallApi/CallApi";
import { DDMMYYYYFormat, YYYYMMDDHHMMAFormat } from "app/_helpers/dateHelper";
import { VFL_STATUS_VIEW } from "app/_pages/_healthSafetyEnvironment/VFL/CONSTANTS";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
let { Store } = configureStore();

export async function getVFL(filter) {
  const viewVflData = Store.getState()?.userManagement?.viewVfl;
  if (!viewVflData?.data?.length || filter) {
    let url = "/global-configuration/ehs-module/vlf" + (filter ? `?${filter}` : "");
    const result = await CallApi(url, "GET");
    const { status, message, data = [] } = result;
    Store.dispatch({
      type: USER_DATA_CONSTANT.VIEW_VFL,
      data: data?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
          mineName: d?.siteData?.name,
          vflStatusView: VFL_STATUS_VIEW[d?.vflStatus],
          areaName: d?.ehs_area_of_operations?.name,
          roId: d?.siteData?.id,
        };
      }),
    });
    return {
      status,
      message,
      data: data?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
          mineName: d?.siteData?.name,
          vflStatusView: VFL_STATUS_VIEW[d?.vflStatus],
          areaName: d?.ehs_area_of_operations?.name,
          roId: d?.siteData?.id,
        };
      }),
    };
  } else {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: viewVflData.data,
        });
      }, 0);
    });
  }
}

export const getAllVFLHistory = async () => {
  let url = "/global-configuration/ehs-module/login-user-vfl-approval-history";
  return await CallApi(url, "GET");
};

export async function myVFL(filter) {
  const myVflData = Store.getState()?.userManagement?.myVfl;
  if (!myVflData?.data?.length || filter) {
    let url = "/global-configuration/ehs-module/myvlf" + (filter ? `?${filter}` : "");
    const result = await CallApi(url, "GET");
    const { status, message, data } = result;
    Store.dispatch({
      type: USER_DATA_CONSTANT.MY_VFL,
      data: Array.isArray(data)
        ? data.map((d, index) => {
            return {
              ...d,
              sid: index + 1,
              vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
              mineName: d?.siteData?.name,
              vflStatusView: VFL_STATUS_VIEW[d?.vflStatus],
              areaName: d?.ehs_area_of_operations?.name,
            };
          })
        : data,
    });
    return {
      status,
      message,
      data: Array.isArray(data)
        ? data.map((d, index) => {
            return {
              ...d,
              sid: index + 1,
              vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
              mineName: d?.siteData?.name,
              vflStatusView: VFL_STATUS_VIEW[d?.vflStatus],
              areaName: d?.ehs_area_of_operations?.name,
            };
          })
        : data,
    };
  } else {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: myVflData.data,
        });
      }, 0);
    });
  }
}

export async function getVFLByID(id) {
  let url = "/global-configuration/ehs-module/vlf/" + id;
  return await CallApi(url, "GET");
}

export async function createVFL(data) {
  let url = "/global-configuration/ehs-module/vlf";
  let result = await CallApi(url, "POST", data);
  if (result.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.MY_VFL,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.VIEW_VFL,
      data: [],
    });
  }
  return result;
}

export async function updateVFL(id, data) {
  let url = "/global-configuration/ehs-module/vlf/" + id;
  let response = await CallApi(url, "PUT", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.MY_VFL,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.VIEW_VFL,
      data: [],
    });
  }
  return response;
}

export async function updateVFLByVFLOfficer(data) {
  let url = "global-configuration/ehs-module/vlf-execution/";
  let response = await CallApi(url, "POST", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.MY_VFL,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.VIEW_VFL,
      data: [],
    });
  }
  return response;
}

export async function updateVFLCapa(id, data) {
  let url = "/global-configuration/ehs-module/vfl-closer/" + id;
  let response = await CallApi(url, "PUT", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.MY_VFL,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.VIEW_VFL,
      data: [],
    });
  }
  return response;
}

export async function deleteVFL(id, data) {
  let url = "/global-configuration/ehs-module/vlf/" + id;
  let response = await CallApi(url, "DELETE", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.MY_VFL,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.VIEW_VFL,
      data: [],
    });
  }
  return response;
}

export const revertedExecutive = async (id, data) => {
  try {
    let url = "/global-configuration/ehs-module/vfl-executive-revert/" + id;

    const response = await RestMethod.PUT(url, data);
    if (response.status) {
      Store.dispatch({
        type: USER_DATA_CONSTANT.MY_VFL,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.VIEW_VFL,
        data: [],
      });
    }
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};
